import footer from "./footer.json";
import newFooter from "./newFooter.json";
import mainOutro from "./main/outro.json";
import mainIntro from "./main/intro.json";
import mainSection1 from "./main/section1.json";
import mainSection2 from "./main/section2.json";
import mainSection3 from "./main/section3.json";
import mainSection4 from "./main/section4.json";
import mainMain from "./main/main.json";
import dcas from "./new_main/dcas.json";
import competitiveness from "./new_main/competitiveness.json";
import realReview from "./new_main/realReview.json";
import subResearcher from "./sub/researcher.json";
import subPurposeAndCharacteristics from "./sub/purposeAndCharacteristics.json";
import subUnderstanding from "./sub/understanding.json";
import subUnderstandingKpass from "./sub/understandingKpass.json";
import subUnderstandingHistory from "./sub/understandingHistory.json";
import subUnderstandingAcademicBasis from "./sub/understandingAcademicBasis.json";
import drawerMenu from "./drawerMenu.json";
import header from "./header.json";
import newHeader from "./newHeader.json";
import parentsWish from "./new_main/parentsWish.json";
import reviewModal from "./modal/reviewModal.json";
import subRealReview from "./sub/realReview.json";
import aboutDcas from './main/aboutDcas.json';
import downloadTest from './sub/downloadTest.json';
import startGuide from './sub/startGuide.json';
import brand from './main/bradnsection.json';
import mypage from "./mypage/mypage.json";
import topBanner from "./mypage/topBanner.json";
import miniGame from "./mypage/miniGame.json";
import profileInfo from "./mypage/profileInfo.json";
import userInfo from "./mypage/userInfo.json";
import checkupInfo from "./mypage/checkupInfo.json";
import consultant from "./mypage/consultant.json";
import payment from "./mypage/payment.json";
import coupon from "./mypage/coupon.json";
import loginBar from "./main/loginbar.json";
import signupModal from "./modal/signupModal.json";
import productDetail from "./voucher/productDetail.json";
import order from "./voucher/order.json";
import modal from "./modal/commonModal.json";
import validation from "./sub/commonValidation.json";

const indexObject = {
  header,
  newHeader,
  footer,
  newFooter,
  mainMain,
  parentsWish,
  dcas,
  competitiveness,
  realReview,
  mainOutro,
  mainIntro,
  mainSection1,
  mainSection2,
  mainSection3,
  mainSection4,
  subResearcher,
  subPurposeAndCharacteristics,
  subUnderstanding,
  subUnderstandingKpass,
  subUnderstandingHistory,
  subUnderstandingAcademicBasis,
  drawerMenu,
  reviewModal,
  subRealReview,
  aboutDcas,
  downloadTest,
  startGuide,
  brand,
  mypage,
  topBanner,
  miniGame,
  profileInfo,
  userInfo,
  checkupInfo,
  consultant,
  payment,
  coupon,
  loginBar,
  signupModal,
  productDetail,
  order,
  modal,
  validation,
};

export default indexObject;
